'use client';

import React, { FC } from 'react';
import { TypeNavListFields } from '@/core/generated-types';
import { NavItem } from '../NavItem';

export const NavList: FC<TypeNavListFields> = ({
  entryName: _entryName,
  title,
  items,
}) => {
  console.log('items', items);
  return (
    <ul
      data-testid="nav-list"
      className="flex flex-col list-none border-t first:border-t-0 border-gray md:border-t-0 py-3 md:py-0 first:pt-0 last:pb-0"
    >
      {title && <li className="md:py-1 py-3 font-bold">{title}</li>}
      {items?.map((item) => (
        <li key={item.sys.id}>
          <NavItem {...item.fields} />
        </li>
      ))}
    </ul>
  );
};

export default React.memo(NavList);
